import { useAtom } from 'jotai';
import React, { useMemo, useState } from 'react';
import { Container } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';

import { ClockIconSvg, HeadsetIconSvg, VideoIconSvg } from '../../assets/images';
import { DefaultHeader } from '../../components/DefaultHeader';
import { HelpPageVideoModal } from '../../components/HelpPageVideoModal';
import { PlatformTourYoutubeVideoID } from '../../enum';
import { userAtom } from '../../jotai-atoms/user.atom';
import { Icon } from '../../stories/Icon';
import { Link } from '../../stories/Link';
import { useGetServicePhoneNumber } from '../../hooks/use-get-service-phone-number';

const ZOOM_DOWNLOAD_URL = 'https://zoom.us/support/download';

export const HelpPage: React.FC = () => {
  const [user] = useAtom(userAtom);

  const [showModal, setShowModal] = useState(false);
  const { callCenterPhone } = useGetServicePhoneNumber();

  const __ = useTranslation().t;

  const youtubeVideoId = useMemo(() => {
    if (user?.lang === 'pt-BR') {
      return PlatformTourYoutubeVideoID.BR;
    }

    return PlatformTourYoutubeVideoID.LATAM;
  }, [user?.lang]);

  return (
    <>
      <DefaultHeader activeItem={__('help')} />
      <Container>
        <div className="oejr-page-help">
          <h3 className="page-title">{__('help')}</h3>
          <p className="page-subtitle">{__('followTipsForBestExperience')}</p>
          <div className="cards-area">
            <div className="help-card">
              <div className="top">
                <div className="image-background with-bg" onClick={() => setShowModal(true)}>
                  <Icon name="circle-play" />
                </div>
              </div>
              <div className="bottom">
                <div className="label">1</div>
                <div className="text-content">{__('watchVideoLearningPlatformExplanation')}</div>
              </div>
            </div>
            <div className="help-card">
              <div className="top">
                <div className="image-background">
                  <VideoIconSvg />
                </div>
              </div>
              <div className="bottom">
                <div className="label">2</div>
                <div className="text-content">
                  <Trans
                    alt={__('accessLiveClassesDownloadZoomApp')}
                    i18nKey="accessLiveClassesDownloadZoomApp"
                  >
                    To access your live classes, you must download and install the{' '}
                    <a href={ZOOM_DOWNLOAD_URL} target="_blank">
                      Zoom application
                    </a>
                    .
                  </Trans>
                </div>
              </div>
            </div>
            <div className="help-card">
              <div className="top">
                <div className="image-background">
                  <HeadsetIconSvg />
                </div>
              </div>
              <div className="bottom">
                <div className="label">3</div>
                <div className="text-content">{__('wearHeadphonesDuringClass')}</div>
              </div>
            </div>
            <div className="help-card">
              <div className="top">
                <div className="image-background">
                  <ClockIconSvg />
                </div>
              </div>
              <div className="bottom">
                <div className="label">4</div>
                <div className="text-content">{__('liveClassStartsAutomaticallyZoom')}</div>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <div className="help-footer">
        <div className="footer-content">
          {__('contactUsQuestionsComments')}
          <span className="email">
            <Link href="mailto:hello@openenglishjunior.com">&nbsp;hello@openenglishjunior.com</Link>
          </span>
          <br />
          {__('contactUsPhoneNumber')}
          <span className="tel">{callCenterPhone}</span>
        </div>
      </div>
      <HelpPageVideoModal setShow={setShowModal} show={showModal} youtubeVideoId={youtubeVideoId} />
    </>
  );
};
